import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { Message, MessageBox } from "element-ui";
import util from "@/libs/util.js";
import router from "@/router";
import api from "@/api";
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload account {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var dispatch, _ref2, _ref2$account, account, _ref2$pwd, pwd, _ref2$other, other, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              dispatch = _ref.dispatch;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$account = _ref2.account, account = _ref2$account === void 0 ? "" : _ref2$account, _ref2$pwd = _ref2.pwd, pwd = _ref2$pwd === void 0 ? "" : _ref2$pwd, _ref2$other = _ref2.other, other = _ref2$other === void 0 ? {} : _ref2$other;
              _context.n = 1;
              return api.SYS_USER_LOGIN(_objectSpread({
                account: account,
                pwd: pwd
              }, other));
            case 1:
              res = _context.v;
              res = res.data;
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天
              util.cookies.set("uuid", res.id);
              util.cookies.set("token", res.token || "no token");
              util.cookies.set("aid", res.aid || "");

              // 设置 vuex 用户信息
              _context.n = 2;
              return dispatch("d2admin/user/set", {
                name: res.name || "Admin"
              }, {
                root: true
              });
            case 2:
              _context.n = 3;
              return dispatch("load");
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref3) {
      var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$confirm = _ref4.confirm,
        confirm = _ref4$confirm === void 0 ? false : _ref4$confirm;
      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认
      function _logout() {
        _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                // 删除 cookie
                util.cookies.remove("token");
                util.cookies.remove("uuid");
                util.cookies.remove("aid");
                // 清空 vuex 用户信息
                _context2.n = 1;
                return dispatch("d2admin/user/set", {}, {
                  root: true
                });
              case 1:
                // 跳转路由到登录页
                console.log('跳转路由');
                router.push({
                  name: "login"
                });
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        commit("d2admin/gray/set", true, {
          root: true
        });
        MessageBox.confirm("确定要退出当前用户吗", "退出用户", {
          type: "warning"
        }).then(function () {
          commit("d2admin/gray/set", false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit("d2admin/gray/set", false, {
            root: true
          });
          Message({
            message: "取消退出操作"
          });
        });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref5) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var dispatch;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              dispatch = _ref5.dispatch;
              _context3.n = 1;
              return dispatch("d2admin/user/load", null, {
                root: true
              });
            case 1:
              _context3.n = 2;
              return dispatch("d2admin/theme/load", null, {
                root: true
              });
            case 2:
              _context3.n = 3;
              return dispatch("d2admin/transition/load", null, {
                root: true
              });
            case 3:
              _context3.n = 4;
              return dispatch("d2admin/page/openedLoad", null, {
                root: true
              });
            case 4:
              _context3.n = 5;
              return dispatch("d2admin/menu/asideLoad", null, {
                root: true
              });
            case 5:
              _context3.n = 6;
              return dispatch("d2admin/size/load", null, {
                root: true
              });
            case 6:
              _context3.n = 7;
              return dispatch("d2admin/color/load", null, {
                root: true
              });
            case 7:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};